module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-04-aa893d9bf1651ad275af5ea34cfac159.jpg";